import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import api from '../../lib/api';

export default function UsageTab() {
    const [engagement, setEngagement] = useState(null);
    const [features, setFeatures] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            api.get('/internal/v1/engagement').catch(() => ({ data: null })),
            api.get('/internal/v1/feature-adoption').catch(() => ({ data: null }))
        ]).then(([e, f]) => { setEngagement(e.data); setFeatures(f.data); }).finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="animate-pulse h-64 bg-slate-900/50 rounded-2xl" />;

    return (
        <div className="space-y-6">
            {engagement && (
                <Card className="bg-slate-900/50 border-white/10">
                    <CardHeader><CardTitle className="text-white">Engagement agences</CardTitle></CardHeader>
                    <CardContent>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 mb-6">
                            {[
                                { value: engagement.wau, label: 'Actives cette semaine', color: 'text-blue-400' },
                                { value: engagement.mau, label: 'Actives ce mois', color: 'text-purple-400' },
                                { value: `${engagement.stickiness}%`, label: 'Fidélité (ratio sem/mois)', color: 'text-green-400' }
                            ].map((m, i) => (
                                <div key={i} className="text-center p-4 rounded-xl bg-white/5">
                                    <p className={`text-3xl font-bold ${m.color}`}>{m.value}</p>
                                    <p className="text-xs text-white/50">{m.label}</p>
                                </div>
                            ))}
                        </div>
                        <h4 className="text-sm font-bold text-white mb-3">Largeur et profondeur d'usage</h4>
                        <div className="space-y-2">
                            {engagement.breadth_depth?.map((b, i) => (
                                <div key={i} className="flex items-center gap-3 p-3 rounded-xl bg-white/[0.03]">
                                    <span className="text-sm text-white font-medium w-32 truncate">{b.name}</span>
                                    <div className="flex-1">
                                        <div className="flex gap-1 mb-1">
                                            {[...Array(b.max_modules)].map((_, j) => (
                                                <div key={j} className={`h-3 flex-1 rounded ${j < b.modules_used ? 'bg-blue-500' : 'bg-white/5'}`} />
                                            ))}
                                        </div>
                                        <p className="text-[10px] text-white/40">{b.modules_used}/{b.max_modules} modules ({b.breadth_pct}%)</p>
                                    </div>
                                    <span className="text-xs text-white/60">Profondeur : {b.depth}</span>
                                </div>
                            ))}
                        </div>
                    </CardContent>
                </Card>
            )}

            {features && (
                <Card className="bg-slate-900/50 border-white/10">
                    <CardHeader><CardTitle className="text-white">Adoption des fonctionnalités</CardTitle></CardHeader>
                    <CardContent>
                        <div className="space-y-3">
                            {features.features?.map((f, i) => (
                                <div key={i} className="flex items-center gap-3">
                                    <span className="text-xs text-white/70 w-40 truncate">{f.feature_name}</span>
                                    <div className="flex-1">
                                        <div className="h-4 bg-white/5 rounded-full overflow-hidden flex">
                                            <div className="h-full bg-blue-500 rounded-l-full" style={{ width: `${f.adoption_rate}%` }} />
                                            <div className="h-full bg-green-500" style={{ width: `${f.reuse_rate * f.adoption_rate / 100}%` }} />
                                        </div>
                                    </div>
                                    <div className="text-right w-28">
                                        <span className="text-xs text-blue-400">{f.adoption_rate}%</span>
                                        <span className="text-[10px] text-white/30 mx-1">|</span>
                                        <span className="text-xs text-green-400">{f.reuse_rate}% reuse</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <p className="text-[10px] text-white/30 mt-3">Bleu = adoption | Vert = réutilisation</p>
                    </CardContent>
                </Card>
            )}
        </div>
    );
}
